const areas = [
  "Houston", "Bellaire", "Pearland", "Sugar Land", "Pasadena",
  "League City", "Baytown", "Missouri City", "Stafford", "Friendswood",
  "La Porte", "Deer Park", "Northshore", "South Houston",
];

export default function ServiceAreas() {
  return (
    <section className="py-20 px-6 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-xs tracking-widest uppercase text-amber-600 mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>Where We Work</p>
            <h2 className="text-4xl md:text-5xl font-light text-stone-900 leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Serving Greater<br /><em className="not-italic font-semibold">Houston, Texas</em>
            </h2>
            <p className="text-stone-500 text-sm leading-relaxed mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
              Archicon Services provides residential and commercial architectural design across Houston and the surrounding metro area. Whether you need a residential architect in Sugar Land or commercial architecture services in Pearland, we bring the same level of precision and design excellence to every project.
            </p>
            <div className="flex flex-wrap gap-2">
              {areas.map((area, i) => (
                <span key={i} className="border border-stone-200 text-stone-600 text-xs tracking-wide px-3 py-1.5 rounded-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {area}
                </span>
              ))}
            </div>
          </div>
          <div className="w-full h-80 rounded-sm overflow-hidden">
            <iframe
              title="Archicon Services Houston Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3464.0!2d-95.5621!3d29.7604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c3ca88e98d9b%3A0x1f0a4b6b6b6b6b6b!2s12111+Gladewick+Dr%2C+Houston%2C+TX+77077!5e0!3m2!1sen!2sus!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
